export const ORDER_LIFECYCLE_STEPS = [
  {
    key: "confirmed",
    label: "Order Confirmed",
    description: "Order has been placed and confirmed.",
    statuses: ["Pending", "Confirmed"],
  },
  {
    key: "pickup-scheduled",
    label: "Pickup Scheduled",
    description: "Pickup window is scheduled with the customer.",
    statuses: ["Pickup Scheduled", "Pickup Rescheduled", "Pickup Confirmed"],
  },
  {
    key: "out-for-pickup",
    label: "Out for Pickup",
    description: "Pickup partner is on the way to collect laundry.",
    statuses: ["Out for Pickup"],
  },
  {
    key: "picked-up",
    label: "Picked Up",
    description: "Laundry has been collected from the customer.",
    statuses: ["Picked Up"],
  },
  {
    key: "at-store",
    label: "At Store",
    description: "Order has arrived at the store for processing.",
    statuses: ["At Store"],
  },
  {
    key: "processing",
    label: "Processing",
    description: "Store is cleaning and preparing the order.",
    statuses: ["Processing", "Delayed"],
  },
  {
    key: "ready",
    label: "Ready for Delivery",
    description: "Order is ready to be handed off for delivery.",
    statuses: ["Ready for Delivery"],
  },
  {
    key: "out-for-delivery",
    label: "Out for Delivery",
    description: "Delivery partner is on the way to the customer.",
    statuses: ["Out for Delivery"],
  },
  {
    key: "delivered",
    label: "Delivered",
    description: "Order has been delivered to the customer.",
    statuses: ["Delivered"],
  },
];

export const ORDER_HOLDER_BY_STATUS = {
  Pending: "Customer",
  Confirmed: "Customer",
  "Pickup Scheduled": "Awaiting pickup partner",
  "Pickup Rescheduled": "Awaiting pickup partner",
  "Pickup Confirmed": "Pickup partner",
  "Out for Pickup": "Pickup partner",
  "Picked Up": "Pickup partner",
  "At Store": "Store",
  Processing: "Store",
  Delayed: "Store",
  "Ready for Delivery": "Store",
  "Out for Delivery": "Delivery partner",
  Delivered: "Customer",
};

export function getLifecycleStepIndex(status) {
  if (!status) return -1;
  return ORDER_LIFECYCLE_STEPS.findIndex((step) =>
    step.statuses.includes(status)
  );
}

export function getOrderHolder(status) {
  return ORDER_HOLDER_BY_STATUS[status] || "—";
}
